import { useLocation } from "react-router-dom";
import styled from "styled-components";
import { beautifyText, formatDate } from "../../utils/helperUtils";
import { CalendarMonthOutlined } from "@mui/icons-material";
import { GuestLayout } from "../../components/layouts/GuestLayout";
import { useEffect } from "react";

export const PostDetails = () => {
  const { state } = useLocation();
  const { title, content, pubDate, categories, link } = state || {};

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, []);

  return (
    <GuestLayout>
      <Wrapper className="x100 flex p20">
        <InnerWrapper>
          <div className="mb20 flexColumn gap20">
            {/* Title */}
            <h2 className="">{title}</h2>

            {/* DATE */}
            <div className="flexNullCenter gap10 grey font14">
              <CalendarMonthOutlined fontSize="small" />
              {formatDate(pubDate)}
            </div>

            {/* Categories */}
            <div
              className="flexNullCenter gap10 wrap"
              style={{ flexWrap: "wrap" }}
            >
              {categories.map((category) => (
                <div
                  key={category}
                  className="lightBg font13 r15"
                  style={{ padding: "7px 15px" }}
                >
                  {beautifyText(category)}
                </div>
              ))}
            </div>
          </div>

          <HTMLWrapper dangerouslySetInnerHTML={{ __html: content }} />

          <a
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            className="main"
          >
            Follow on Medium
          </a>
        </InnerWrapper>
      </Wrapper>
    </GuestLayout>
  );
};

const Wrapper = styled.div`
  justify-content: center;
`;

const InnerWrapper = styled.div`
  max-width: 680px;
`;

const HTMLWrapper = styled.div`
  line-height: 1.5;
  & > * {
    margin-bottom: 1rem;
  }

  figure img {
    width: 100%;
    border-radius: 15px;
  }

  h4 {
    margin-top: 3rem;
  }

  ol {
    margin-left: 30px;
  }
  li {
    margin-bottom: 0.5rem;
  }
`;
